/**
 * Composable for text counting utilities
 * Single Responsibility: Manages all text counting logic
 */

export interface TextCountStats {
  characters: number
  charactersNoSpaces: number
  words: number
  lines: number
  koreanChars: number
  remaining?: number
  isMaxReached: boolean
}

export function useTextCounter(
  text: string,
  options: {
    countSpaces?: boolean
    maxLength?: number
  } = {}
) {
  const { countSpaces = true, maxLength } = options

  // Character count
  const characters = countSpaces 
    ? text.length 
    : text.replace(/\s/g, '').length

  // Character count without spaces
  const charactersNoSpaces = text.replace(/\s/g, '').length

  // Word count - handles Korean text better
  const words = text.trim() 
    ? text.trim().split(/[\s\u3000]+/).filter(word => word.length > 0).length 
    : 0

  // Line count
  const lines = text ? text.split('\n').length : 0

  // Korean character count
  const koreanRegex = /[\u3131-\uD79D]/g
  const koreanMatches = text.match(koreanRegex)
  const koreanChars = koreanMatches ? koreanMatches.length : 0

  // Remaining characters
  const remaining = maxLength ? maxLength - characters : undefined
  const isMaxReached = maxLength ? characters >= maxLength : false

  return {
    characters,
    charactersNoSpaces,
    words,
    lines,
    koreanChars,
    remaining,
    isMaxReached
  }
}